import type { OperatorAvatarFilterOperator } from '@/shared/components/ui/OperatorAvatarFilter';

/**
 * Usuário de um funil/pipeline devolvido pelo servidor. Dois usos:
 * - filtro por operador (`GET /{leads,tickets}/operators/dropdown`): quem
 *   participa do contexto + quem tem registro atribuído nele (desativados e
 *   excluídos só vêm pelo segundo caminho);
 * - escolha do responsável (`GET /{leads,tickets}/assignees/dropdown`): quem
 *   participa, em qualquer papel — sempre `status: 'active'`.
 */
export interface ContextOperatorFilterUser {
  id: string;
  name: string;
  email?: string;
  avatar?: string;
  status: 'active' | 'inactive' | 'deleted';
}

const STATUS_SUFFIX: Record<ContextOperatorFilterUser['status'], string> = {
  active: '',
  inactive: ' (inativo)',
  deleted: ' (excluído)',
};

/** Formato do `<OperatorAvatarFilter>`, com o status no nome de quem não está ativo. */
export const toOperatorFilterOperator = (user: ContextOperatorFilterUser): OperatorAvatarFilterOperator => ({
  id: user.id,
  name: `${user.name}${STATUS_SUFFIX[user.status]}`,
  ...(user.avatar ? { avatar: user.avatar } : {}),
});
